import { makeIssues } from 'ducks/integrations/jiraShared'

export default makeIssues('integrations/jira_cloud')
